import {h, Fragment} from "preact"
import { useAppState, SerpElement } from "@nosto/preact";
import { useState, useMemo } from "preact/hooks";
import ProductQuickSwatch from "./ProductQuickSwatch";
import { formatCurrency, showSubtitle, staticBundleAtc } from "../helpers";

export default ({ isMobile, product, isCustomer }) => {
  const tags = [
    product.onSale
      ? {
          label: "Sale",
          class:
            "ns-badge ns-badge-green-outline ns-d-inline-block ns-text-align-center",
        }
      : undefined,
  ].filter((v) => !!v);

  const { pageType } = useAppState();
  const url = useMemo(
    () =>
      pageType === "category"
        ? location.origin +
          location.pathname +
          "/products/" +
          product.url.split("/products/")[1]
        : false,
    [pageType]
  );

  const [currentVariant, setCurrentVariant] = useState(product.skus?.[0]);

  const getCustomFieldValue = (customFields, key) => {
    if(!customFields) return null;
    const field = customFields.find((field) => field.key === key);
    return field ? field.value : null;
  };

  const staticBundleDisplayPrice = getCustomFieldValue(
    product.customFields,
    "bundle-display_price"
  );
  const staticBundleCompareAtPrice = getCustomFieldValue(
    product.customFields,
    "bundle-display_compare_at_price"
  );

  const bundle = product.tags1?.includes("nosto:dynamic_bundle");

  const isSwymComingSoon = getCustomFieldValue(product.customFields, 'custom-swym_coming_soon') || getCustomFieldValue(product.skus?.[0]?.customFields, 'custom-swym_coming_soon');
  const isSwymDisabled = getCustomFieldValue(product.customFields, 'custom-swym_disabled') || getCustomFieldValue(product.skus?.[0]?.customFields, 'custom-swym_disabled');

  //console.log('product', product, 'coming soon', isSwymComingSoon, 'swym disabled', isSwymDisabled);

  return (
    <SerpElement
      as="div"
      hit={product}
      className="product-tile availability--in-stock price--regular product-tile--grid"
      role="group"
      aria-label="product"
      data-handle={product.url.split("/products/")[1]}
    >
      <div className="product-tile__image">
        <div className="product__badges" tags={product.tags1}>
          {product?.tags1?.includes("badge::new") && (
            <div className="badge badge--new">new</div>
          )}
          {product?.tags1?.includes("badge::best") && (
            <div className="badge badge--best">best</div>
          )}
          {product?.tags1?.includes("badge::exclusive") && (
            <div className="badge badge--exclusive">exclusive</div>
          )}

          {product?.tags1?.includes("badge::Sydney's Pick") && (
            <div className="badge badge--sydneys-pick">Sydney's Pick</div>
          )}
        </div>

        <a
          className="product-tile__link"
          ap-prd-name={product.name}
          ap-prd-id={product.productId}
          ap-prd-price={product.price}
          ap-prd-brand={product.brand}
          id={`product_${product.productId}`}
          href={
            currentVariant
              ? `${url ? url : product.url}`
              : url
              ? url
              : product.url
          }
        >
          <img
            src={product.imageUrl}
            alt={product.name}
            srcset={product.imageUrl}
            width="304"
            height="304"
            loading="lazy"
          />
        </a>
      </div>
      <div className="product-tile__details">
        <div className="product-tile__header">
          <h2 className="product-tile__title">
            <a
              className="product-tile__link"
              href={
                currentVariant
                  ? `${url ? url : product.url}?variant=${currentVariant.id}`
                  : url
                  ? url
                  : product.url
              }
            >
              {product.name}
            </a>
          </h2>
          <h3 className="product-tile__subtitle caption-responsive">
            {showSubtitle(product, product.name)}
          </h3>
        </div>
        <div className="product-tile__quick-add">
          {product.tags1?.includes("exclusive_product") &&
          isCustomer === false ? (
            <a
              className="button button--secondary"
              title={product.name}
              href={product.url}
            >
              <span>Loyalty Exclusive</span>
            </a>
          ) : (
            <form
              method="post"
              action="/cart/add"
              id=""
              accept-charset="UTF-8"
              className="form--product"
              enctype="multipart/form-data"
            >
              <input type="hidden" name="form_type" value="product" />
              <input type="hidden" name="utf8" value="✓" />
              {product.skus.length > 1 ? (
                <div className="quick-add-swatches">
                  <ProductQuickSwatch product={product} />
                </div>
              ) : (
                <input
                  type="hidden"
                  className="id-input"
                  name="id"
                  value={product.skus[0]?.id}
                />
              )}

              {/* ATC BUTTON:
                1. product 'out of stock'
                    - appearance: "Out of Stock"
                    - onclick: <a href>
                2. product 'in stock' 
                    a. and is a DYNAMIC bundle (takes to PDP)
                        - appearance: no price, "build your bundle"
                        - onclick: <a href>
                    b. and is a waitlisted product (takes to PDP)
                        - appearance: no price, "Join The Waitlist"
                        - onclick: <a href>
                    c. and is a STATIC bundle
                        - appearance: price + "Quick add"
                        - onclick: window.theme.addStaticBundleToCart()
                    d. and is normal product
                        - appearance: price + "Quick add"
                        - onclick: <form> submit || window.cart.add()
                */}

              {isSwymDisabled === true && product.availability === "OutOfStock" ? (
                <a
                  href={
                    currentVariant
                      ? `${url ? url : product.url}?variant=${
                          currentVariant.id
                        }`
                      : url
                      ? url
                      : product.url
                  }
                  className="button is-disabled"
                >
                  <span class="label">Out of stock</span>
                </a>
              ) : product.availability === "OutOfStock" ? (
                <a
                  href={
                    currentVariant
                      ? `${url ? url : product.url}?variant=${
                          currentVariant.id
                        }`
                      : url
                      ? url
                      : product.url
                  }
                  className="button button--secondary"
                >
                  <span class="label">Notify me</span>
                </a>
              ) : isSwymComingSoon ? (
                <a
                  href={
                    currentVariant
                      ? `${url ? url : product.url}?variant=${
                          currentVariant.id
                        }`
                      : url
                      ? url
                      : product.url
                  }
                  className="button button--secondary"
                >
                  <span class="label">Notify me</span>
                </a>
              ) : product.tags1?.includes("nosto:dynamic_bundle") ? (
                <a href={product.url} className="button button--secondary">
                  <span class="label">Build Your Bundle</span>
                </a>
              ) : product.tags1?.includes("nosto:static_bundle") ? (
                <button
                  className="button button--secondary"
                  type="button"
                  onClick={() => {
                    staticBundleAtc(product.skus[0]?.id, 1);
                  }}
                >
                  <span
                    className="nosto-price"
                    data-current-price
                  >{`$${staticBundleDisplayPrice}`}</span>

                  {staticBundleCompareAtPrice && (
                    <span className="old-price" data-compare-price>
                      ${staticBundleCompareAtPrice}
                    </span>
                  )}
                  <span className="divider">|</span>
                  <span className="label">Quick add</span>
                </button>
              ) : (
                <button
                  className="button button--secondary"
                  type="submit"
                  data-product-id={product.productId}
                >
                  <span className="nosto-price" data-current-price>
                    {formatCurrency(
                      currentVariant ? currentVariant.price : product.price
                    )}
                  </span>
                  {((currentVariant &&
                    currentVariant.listPrice > currentVariant.price) ||
                    (!currentVariant && product.listPrice > product.price)) && (
                    <span className="old-price" data-compare-price>
                      {formatCurrency(
                        currentVariant
                          ? currentVariant.listPrice
                          : product.listPrice
                      )}
                    </span>
                  )}
                  <span className="divider">|</span>
                  <span className="label">Quick add</span>
                </button>
              )}

              <input
                type="hidden"
                name="product-id"
                value={product.productId}
              />
              <input
                type="hidden"
                name="section-id"
                value="nosto-search-results-div"
              />
            </form>
          )}
        </div>
        <div className="product-tile__footer">
          <div
            className="yotpo bottomLine yotpo-small"
            style="height: 27.5px;"
            data-product-id={product.productId}
          ></div>
        </div>
      </div>
    </SerpElement>
  );
};
